"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinForm_JoinBtnType = exports.protobufPackage = void 0;
exports.protobufPackage = "";
var JoinForm_JoinBtnType;
(function (JoinForm_JoinBtnType) {
    JoinForm_JoinBtnType["JOIN_BTN_TYPE_UNSPECIFIED"] = "JOIN_BTN_TYPE_UNSPECIFIED";
    JoinForm_JoinBtnType["JOIN_BTN_TYPE_JOIN_AND_GO_LIVE"] = "JOIN_BTN_TYPE_JOIN_AND_GO_LIVE";
    JoinForm_JoinBtnType["JOIN_BTN_TYPE_JOIN_ONLY"] = "JOIN_BTN_TYPE_JOIN_ONLY";
})(JoinForm_JoinBtnType || (exports.JoinForm_JoinBtnType = JoinForm_JoinBtnType = {}));
